const formtrans ={
    name:{
        english: "Name",
        persian: "نام"
    },
    clothSize:{
        english: "Cloth Size",
        persian: "سایز لباس"
    },
    store:{
        english: "Store",
        persian: "انبار"
    },
    deleteNews:{
        english: "Delete News",
        persian: "حذف خبر"
    },
    hse:{
        english: "HSE",
        persian: "HSE"
    },
    birthDay:{
        english: "Birth Day",
        persian: "روز تولد"
    },
    senfiCode:{
        english: "senfi code",
        persian: "کد صنفی"
    },
    teamUsers:{
        english: "Users",
        persian: "کاربران"
    },
    newPassword:{
        english: "New Password",
        persian: "رمز جدید"
    },
    confirmPassword:{
        english: "Confirm Password",
        persian: "تایید رمز جدید"
    },
    StockId:{
        english: "Stock Id",
        persian: "شناسه صنفی"
    },
    zone:{
        english: "zone",
        persian: "منطقه"
    },
    roleId:{
        english: "RoleId",
        persian: "کد نقش"
    },
    workTime:{
        english: "Work Time",
        persian: "ساعت کاری"
    },
    fname:{
        english: "Last Name",
        persian: "نام خانوادگی"
    },
    title:{
        english: "Title",
        persian: "نام"
    },
    enTitle:{
        english: "English Title",
        persian: "نام انگلیسی"
    },
    link:{
        english: "Linke",
        persian: "لینک"
    },
    phoneNumber:{
        english: "Phone Number",
        persian: "شماره تماس"
    },
    EmergencyContact:{
        english: "Emergency Contact",
        persian: "شماره تماس ضروری"
    },
    userRelatedContacts:{
        english: "User Related Contacts",
        persian: "شماره تماس افراد مرتبط"
    },
    nif:{
        english: "location",
        persian: "موقعیت مکانی"
    },
    mobile:{
        english: "Mobile",
        persian: "شماره همراه"
    },
    status:{
        english: "Status",
        persian: "وضعیت"
    },
    statusOfRealOrJur:{
        english: "Real",
        persian: "حقیقی"
    },
    emailAddress:{
        english: "Email Address",
        persian: "آدرس ایمیل"
    },
    gcode:{
        english: "Gallery Code",
        persian: "کد گالری"
    },
    customercode:{
        english: "Customer Code",
        persian: "کد مشتری"
    },
    postalCode:{
        english: "Postal Code",
        persian: "کد پستی"
    },
    meliCode:{
        english: "Meli Code",
        persian: "کد ملی/شناسه ملی"
    },
    address:{
        english: "Address",
        persian: "آدرس"
    },
    country:{
        english: "Country",
        persian: "کشور"
    },
    city:{
        english: "City",
        persian: "شهرستان"
    },
    state:{
        english: "State/Region",
        persian: "استان"
    },
    about:{
        english: "About",
        persian: "درباره"
    },
    saveChanges:{
        english: "Save Changes",
        persian: "ذخیره تغییرات"
    },
    saveAndClose:{
        english: "Save And Close",
        persian: "ذخیره و بازگشت"
    },
    brandCode:{
        english: "Brand Code",
        persian: "کد برند"
    },
    newService:{
        english: "New Service",
        persian: "خدمات جدید"
    },
    catCode:{
        english: "Category Code",
        persian: "کد دسته بندی"
    },
    catParent:{
        english: "Category Parent",
        persian: "پرنت دسته بندی"
    },
    cancel:{
        english: "Cancel",
        persian: "انصراف"
    },
    sku:{
        english: "SKU",
        persian: "شناسه"
    },
    unit:{
        english: "Unit",
        persian: "واحد"
    },
    saleInformation:{
        english: "Sale Information",
        persian: "اطلاعات فروش"
    },
    sellingPrice:{
        english: "Selling Price",
        persian: "قیمت فروش"
    },
    purchaseInformation:{
        english: "Purchase Information",
        persian: "اطلاعات خرید"
    },
    purchasePrice:{
        english: "Purchase Price",
        persian: "قیمت خرید"
    },
    description:{
        english: "Description",
        persian: "توضیحات"
    },
    customercode:{
        english: "Customer Code",
        persian: "کد مشتری"
    },
    customer:{
        english: "Customer",
        persian: "مشتری"
    },
    class:{
        english: "Class",
        persian: "کلاس"
    },
    classcode:{
        english: "Class Code",
        persian: "کد کلاس"
    },
    brand:{
        english: "Brand",
        persian: "برند"
    },
    brandManage:{
        english: "Brand Manage",
        persian: "مدیریت برند"
    },
    value:{
        english: "Value",
        persian: "مقدار"
    },
    discount:{
        english: "Discount",
        persian: "تخفیف"
    },
    category:{
        english: "Category",
        persian: "دسته بندی"
    },
    type:{
        english: "Type",
        persian: "نوع"
    },
    options:{
        english: "options",
        persian: "انتخاب ها"
    },
    optionsN:{
        english: "Negative Options",
        persian: "انتخاب های منفی"
    },
    filter:{
        english: "Filter",
        persian: "فیلتر"
    },
    filters:{
        english: "Filters",
        persian: "فیلترها"
    },
    factoryManage:{
        english: "Factory Manage",
        persian: "مدیریت تولیدکننده"
    },
    factory:{
        english: "Factory",
        persian: "تولیدکننده"
    },
    message:{
        english: "Message",
        persian: "پیام"
    },

    // form users

    addUser:{
        english:"Add User",
        persian: "کاربر جدید"
    },
    
    users:{
        english:"Users",
        persian: "کاربران"
    },
    role:{
        english:"Role",
        persian: "نقش"
    },
    group:{
        english:"Group",
        persian: "گروه"
    },
    lastAccess:{
        english:"Last Access",
        persian: "آخرین دسترسی"
    },
    searchUser:{
        english:"Search Users ...",
        persian: "جستجوی کاربر"
    },
    access:{
        english:"Access",
        persian: "دسترسی"
    },
    profile:{
        english:"Profile",
        persian: "پروفایل"
    },
    email:{
        english:"Email",
        persian: "ایمیل"
    },
    username:{
        english:"Username",
        persian: "نام کاربری"
    },

    

}
export default formtrans